/** Re-exports the auto-generated types and defines additional content that should not get overwritten when types are generated. */

import { Currency, CurrencyMinorUnits } from "./iso4217/currencies";

// Re-export these for external use

/** @returns The symbol for the given currency (ex: $ for USD) */
export function getCurrencySymbol(currency: Currency): string {
  return (0)
    .toLocaleString(undefined, {
      style: "currency",
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/\d/g, "")
    .trim();
}

/** @returns The narrow symbol for the given currency (ex: $ for USD) */
export function getNarrowCurrencySymbol(currency: Currency): string {
  return (0)
    .toLocaleString(undefined, {
      style: "currency",
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      currencyDisplay: "narrowSymbol",
    })
    .replace(/\d/g, "")
    .trim();
}

// If (typeof CurrencyMinorUnits)[C] is null, then the minor units is 2
// otherwise, the minor units is the value of (typeof CurrencyMinorUnits)[C]
export type MinorUnits<C extends Currency> = C extends any
  ? (typeof CurrencyMinorUnits)[C] extends null
    ? 2
    : (typeof CurrencyMinorUnits)[C]
  : never;

export function getCurrencyMinorUnits<C extends Currency>(
  currency: C,
): MinorUnits<C> {
  return (CurrencyMinorUnits[currency] ?? 2) as MinorUnits<C>;
}

export function convertAmountToDifferentCurrencyWithExchangeRate({
  amountInOriginalCurrency,
  exchangeRate,
  toCurrency,
}: {
  amountInOriginalCurrency: Big;
  exchangeRate: Big;
  toCurrency: Currency;
}): string {
  return amountInOriginalCurrency
    .times(exchangeRate)
    .toFixed(getCurrencyMinorUnits(toCurrency));
}

export {
  amountToMinorUnits,
  CURRENCIES,
  Currency,
  CurrencyMinorUnits,
  CurrencyNames,
  isCurrency,
  minorUnitsToAmount,
  minorUnitsToAmountString,
} from "./iso4217/currencies";
